'use client';
import { CollectionDescription as Shared } from '@launchstore/shared-puck';
export const CollectionDescription: any = Shared;
export default CollectionDescription;
